export default __webpack_public_path__ + "static/media/app-menu.819d02d9.svg";